import { render, staticRenderFns } from "./BudgetTable.vue?vue&type=template&id=15b66dc4&scoped=true"
import script from "./BudgetTable.vue?vue&type=script&lang=js"
export * from "./BudgetTable.vue?vue&type=script&lang=js"
import style0 from "./BudgetTable.vue?vue&type=style&index=0&id=15b66dc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b66dc4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/BudgetTable.vue
// module id = 1985
// module chunks = 31